export default __webpack_public_path__ + "static/media/DAI.f3067a52.svg";